import React, { useState } from 'react';
import { Share2, X, Twitter, Linkedin, Link2, Check } from 'lucide-react';

const ShareButton = ({ title, description, url }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const shareTitle = title || document.title;
  const shareText = description || '';

  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareTitle)}&url=${encodeURIComponent(shareUrl)}`;
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const input = document.createElement('input');
      input.value = shareUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="fixed bottom-20 right-6 z-50" data-testid="share-button-container">
      {isOpen && (
        <div className="absolute bottom-16 right-0 bg-gray-900 border border-gray-700 rounded-xl p-3 shadow-2xl shadow-black/50 min-w-[180px] animate-fadeInUp" data-testid="share-menu">
          <div className="text-xs text-gray-400 font-medium mb-2 px-1">Share this page</div>
          <a
            href={twitterUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-gray-800 transition-colors text-gray-300 hover:text-white"
            data-testid="share-twitter"
          >
            <Twitter size={16} />
            <span className="text-sm">Twitter / X</span>
          </a>
          <a
            href={linkedinUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-gray-800 transition-colors text-gray-300 hover:text-white"
            data-testid="share-linkedin"
          >
            <Linkedin size={16} />
            <span className="text-sm">LinkedIn</span>
          </a>
          <button
            onClick={copyLink}
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-gray-800 transition-colors text-gray-300 hover:text-white"
            data-testid="share-copy-link"
          >
            {copied ? <Check size={16} className="text-green-400" /> : <Link2 size={16} />}
            <span className="text-sm">{copied ? 'Copied!' : 'Copy Link'}</span>
          </button>
        </div>
      )}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 ${
          isOpen
            ? 'bg-gray-700 hover:bg-gray-600 rotate-90'
            : 'bg-gradient-to-r from-purple-600 to-cyan-600 hover:from-purple-500 hover:to-cyan-500 hover:scale-110'
        }`}
        data-testid="share-toggle-button"
        aria-label="Share this page"
      >
        {isOpen ? <X size={20} className="text-white" /> : <Share2 size={20} className="text-white" />}
      </button>
    </div>
  );
};

export default ShareButton;
